import React from 'react'
import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'
import { Alert } from '@smooth-ui/core-sc'

import PageWrapper from 'components/PageWrapper/PageWrapper'
import ListView, { fragment } from 'components/ListView/ListView'
import { LoadingSpinnerFullscreen } from 'components/Spinner/Spinner'
import HtmlContent from 'components/HtmlContent/HtmlContent'

import useTitle from 'helpers/useTitle'

import routeConfig from 'routeConfig'

const Category = ({
  match: {
    params: { after, slug },
    url
  }
}) => {
  const { data, loading } = useQuery(query, {
    variables: {
      first: 9,
      after,
      slug
    }
  })
  const found =
    data &&
    data.categories &&
    !!data.categories.nodes.length &&
    data.categories.nodes[0]
  const { title, titleView } = useTitle(
    found ? found.name : loading ? null : 'Kategori ikke funnet'
  )
  return (
    <PageWrapper title={title}>
      {titleView}
      {loading && !found && <LoadingSpinnerFullscreen />}
      {!loading && !found && <Alert>Ingen kategori funnet på "{slug}"</Alert>}
      {found && (
        <>
          <HtmlContent mb={2} mt={-1} content={found.description} />
          <ListView
            {...data.posts}
            baseUrl={`${routeConfig.category}/${slug}`}
            after={after}
            backState={{ fromUrl: url, fromName: title }}
          />
        </>
      )}
    </PageWrapper>
  )
}

const query = gql`
  query Posts($first: Int!, $after: String, $slug: String!) {
    posts(first: $first, after: $after, where: { categoryName: $slug }) {
      ...PostList
    }
    categories(where: { slug: [$slug] }) {
      nodes {
        name
        description
      }
    }
  }
  ${fragment}
`

export default Category
